// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main_content[data-v-bf5755d2]{background:#fff;width:100%;height:100%;display:flex;justify-content:center;align-items:center}.main_content .center[data-v-bf5755d2]{text-align:center;line-height:20px;width:300px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
